import { FeaThicknessUpdateService } from './processes/fea-thickness-update.service';
import { FeaPanelRecognitionService } from './processes/fea-panel-recognition.service';
import { FeaLoadService } from './processes/fea-load.service';
import { FeaMOUService } from './processes/fea-mou.service';
import { FeaDLAService } from './processes/fea-dla.service';
import { FeaNastranService } from './processes/fea-nastran.service';
import { Injectable } from '@angular/core';
import { FeaConditionService } from './fea-condition.service';
import { FeaCriticalAreasService } from './processes/fea-critical-areas.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FeaBaseProcessService } from './processes/fea-base-process.service';
import { NotificationService } from 'src/app/signalr/notification.service';
import { firstValueFrom } from 'rxjs';
import { FeaFloatingDryDockCheckService } from './processes/fea-floating-dry-dock-check.service';
import { FeaFatigueService } from './processes/fea-fatigue.service';

@Injectable({
  providedIn: 'root'
})
export class FeaProcessService {
  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
    private readonly feaNastran: FeaNastranService,
    private readonly feaDLA: FeaDLAService,
    private readonly feaMOU: FeaMOUService,
    private readonly feaFloatingDryDockChecks: FeaFloatingDryDockCheckService,
    private readonly feaLoad: FeaLoadService,
    private readonly feaThicknessUpdate: FeaThicknessUpdateService,
    private readonly feaPanelRecognition: FeaPanelRecognitionService,
    private readonly feaCondition: FeaConditionService,
    private readonly feaCriticalAreas: FeaCriticalAreasService,
    private readonly feaFatigue: FeaFatigueService,
  ) {
  }

  public async getProcessResult(processName: string, vectorName: string, byNode: boolean = false) : Promise<any> {
    switch (processName) {
      case 'Nastran':
        return await this.feaNastran.getResult(vectorName, byNode);
      case 'DLA':
        return await this.feaDLA.getResult(vectorName);
      case 'MOU':
        return await this.feaMOU.getResult(vectorName);
      case 'FloatingDryDockChecks':
        return await this.feaFloatingDryDockChecks.getResult(vectorName);
      case 'Load':
        return await this.feaLoad.getResult();
      case 'PanelRecognition':
        return await this.feaPanelRecognition.getResult(vectorName);
      case 'FEACriticalAreas':
        return await this.feaCriticalAreas.getResult(vectorName);
      case 'CodeChecks':
        return await this.feaCondition.getResult("CodeChecks");
      case 'Reliability':
        return await this.feaCondition.getResult("Reliability");
      case 'ThicknessUpdate':
        return await this.feaThicknessUpdate.getResult();
      case 'Fatigue':
        return await this.feaFatigue.getResult();
      default:
        return null;
    }
  }

  public async hasAvailableResultsOnDate(processName: string): Promise<boolean> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    baseRequest.Process = processName;

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    try {
      const availableResultIds = await firstValueFrom(this.http.post<string[]>(environment.API_FEA + "Process/HasAvailableResultsOnDate", baseRequest, options));
      return availableResultIds != null && availableResultIds.length > 0;
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification(`Failed to check if there are ${processName} results available on date`);
      return false;
    }
  }
}
